(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
const nxImageCache = new Map();

function nxImageKeyFromElement(img) {
  if (!img) return '';
  return [img.getAttribute('srcset') || '', img.getAttribute('sizes') || '', img.currentSrc || img.getAttribute('src') || ''].join('|');
}

function nxWarmImageSource({ src = '', srcset = '', sizes = '' } = {}) {
  const key = [srcset, sizes, src].join('|');
  if (!src && !srcset) return Promise.resolve(false);
  const existing = nxImageCache.get(key);
  if (existing) return existing.promise;

  const preload = new Image();
  preload.decoding = 'async';
  try { preload.fetchPriority = 'low'; } catch (_) {}
  if (sizes) preload.sizes = sizes;
  if (srcset) preload.srcset = srcset;
  if (src) preload.src = src;

  const record = { ready: false, promise: null };
  record.promise = new Promise((resolve) => {
    let settled = false;
    const finish = async (ok) => {
      if (settled) return;
      settled = true;
      if (ok && typeof preload.decode === 'function') {
        try { await preload.decode(); } catch (_) {}
      }
      record.ready = ok || preload.naturalWidth > 0;
      resolve(record.ready);
    };

    if (preload.complete) {
      finish(preload.naturalWidth > 0);
      return;
    }
    preload.addEventListener('load', () => finish(true), { once: true });
    preload.addEventListener('error', () => finish(false), { once: true });
  });
  nxImageCache.set(key, record);
  return record.promise;
}

function nxWarmDomImage(img) {
  if (!img) return Promise.resolve(false);
  const src = img.currentSrc || img.getAttribute('src') || '';
  const srcset = img.getAttribute('srcset') || '';
  const sizes = img.getAttribute('sizes') || '';
  return nxWarmImageSource({ src, srcset, sizes });
}

function nxIsDomImageWarm(img) {
  if (!img) return false;
  if (img.complete && img.naturalWidth > 0) return true;
  const record = nxImageCache.get(nxImageKeyFromElement(img));
  return Boolean(record?.ready);
}

function nxRunIdle(callback, timeout = 1200) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout });
  } else {
    window.setTimeout(callback, 180);
  }
}

function nxInitPdpGallerySpeed() {
  const mainImage = document.getElementById('NXMainImage');
  const thumbs = Array.from(document.querySelectorAll('#NXThumbs .nx-thumb[data-large]'));
  if (!mainImage || thumbs.length < 2) return;

  const warmThumb = (button) => {
    if (!button) return Promise.resolve(false);
    return nxWarmImageSource({
      src: button.dataset.src || button.dataset.large || '',
      srcset: button.dataset.srcset || '',
      sizes: button.dataset.sizes || mainImage.getAttribute('sizes') || '',
    });
  };

  const activeIndex = () => {
    const index = thumbs.findIndex((button) => button.classList.contains('is-active'));
    return index >= 0 ? index : 0;
  };

  const warmAdjacent = () => {
    const current = activeIndex();
    const next = thumbs[(current + 1) % thumbs.length];
    const prev = thumbs[(current - 1 + thumbs.length) % thumbs.length];
    warmThumb(next);
    if (prev !== next) warmThumb(prev);
  };

  thumbs.forEach((button) => {
    button.addEventListener('pointerenter', () => { warmThumb(button); }, { passive: true });
    button.addEventListener('focus', () => { warmThumb(button); }, { passive: true });
    button.addEventListener('touchstart', () => { warmThumb(button); }, { passive: true });
    button.addEventListener('click', () => {
      warmThumb(button);
      window.setTimeout(warmAdjacent, 0);
    }, { passive: true });
  });

  nxRunIdle(warmAdjacent, 500);

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const canProgressivelyWarm = !connection?.saveData && !/^(slow-)?2g$/i.test(connection?.effectiveType || '');
  if (canProgressivelyWarm) {
    const warmRest = () => {
      const current = activeIndex();
      const order = thumbs
        .map((button, index) => ({ button, distance: Math.min((index - current + thumbs.length) % thumbs.length, (current - index + thumbs.length) % thumbs.length) }))
        .sort((a, b) => a.distance - b.distance)
        .map((item) => item.button);
      order.forEach((button, index) => {
        window.setTimeout(() => { warmThumb(button); }, index * 260);
      });
    };
    if (document.readyState === 'complete') nxRunIdle(warmRest, 1400);
    else window.addEventListener('load', () => nxRunIdle(warmRest, 1400), { once: true });
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'src')) {
      nxRunIdle(warmAdjacent, 350);
    }
  });
  observer.observe(mainImage, { attributes: true, attributeFilter: ['src'] });
}

function nxGetCollectionPreviewImage(card) {
  const slideshow = card?.refs?.slideshow;
  const slides = slideshow?.slides;
  if (!slides?.length) return null;
  const current = slides[slideshow.current];
  return current?.nextElementSibling?.querySelector('img') || null;
}

function nxWarmCollectionPreview(card) {
  const image = nxGetCollectionPreviewImage(card);
  if (!image) return Promise.resolve(false);
  return nxWarmDomImage(image);
}

function nxObserveCollectionCards() {
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      nxWarmCollectionPreview(entry.target);
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '700px 0px' });

  const scan = (root = document) => {
    const cards = root.matches?.('product-card') ? [root] : Array.from(root.querySelectorAll?.('product-card') || []);
    for (const card of cards) {
      if (card.dataset.nxHoverWarmObserved === '1') continue;
      card.dataset.nxHoverWarmObserved = '1';
      observer.observe(card);
    }
  };

  scan();
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
}

function nxPatchCollectionHover() {
  if (!customElements.get('product-card')) return;
  const ProductCard = customElements.get('product-card');
  const prototype = ProductCard.prototype;
  if (prototype.__nxImageSpeedPatched) return;

  const originalPreviewImage = prototype.previewImage;
  const originalResetImage = prototype.resetImage;
  if (typeof originalPreviewImage !== 'function' || typeof originalResetImage !== 'function') return;

  Object.defineProperty(prototype, '__nxImageSpeedPatched', { value: true, configurable: false });

  prototype.previewImage = function previewImageWithWarmup(event) {
    if (event?.pointerType !== 'mouse') return originalPreviewImage.call(this, event);
    const image = nxGetCollectionPreviewImage(this);
    if (!image) return originalPreviewImage.call(this, event);
    if (nxIsDomImageWarm(image)) {
      this.__nxImagePreviewApplied = true;
      return originalPreviewImage.call(this, event);
    }

    const token = (this.__nxImageHoverToken || 0) + 1;
    this.__nxImageHoverToken = token;
    nxWarmDomImage(image).then(() => {
      if (this.__nxImageHoverToken !== token || !this.matches(':hover')) return;
      this.__nxImagePreviewApplied = true;
      originalPreviewImage.call(this, event);
    });
  };

  prototype.resetImage = function resetImageWithWarmupCancel(event) {
    this.__nxImageHoverToken = (this.__nxImageHoverToken || 0) + 1;
    if (event?.pointerType === 'mouse' && !this.__nxImagePreviewApplied) return;
    this.__nxImagePreviewApplied = false;
    return originalResetImage.call(this, event);
  };
}

function nxInitCollectionHoverSpeed() {
  if (!document.querySelector('product-card')) return;
  customElements.whenDefined('product-card').then(() => {
    nxPatchCollectionHover();
    nxObserveCollectionCards();
  });
}

function nxInitImagePerformance() {
  nxInitPdpGallerySpeed();
  nxInitCollectionHoverSpeed();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', nxInitImagePerformance, { once: true });
} else {
  nxInitImagePerformance();
}

